import IntermissionButtonContainer from './IntermissionButtonContainer';
export default IntermissionButtonContainer;
